import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShoppingBag } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  return <motion.a href="http://checkout.pixastore.online/cart/42176617414750:1" target="_blank" rel="noopener noreferrer" className={`
        inline-flex items-center justify-center gap-2
        bg-gradient-to-r from-pink-500 to-purple-600 
        text-white font-bold text-lg md:text-xl uppercase tracking-wide
        py-4 px-8 rounded-full shadow-lg shadow-pink-500/30
        hover:shadow-xl hover:shadow-pink-500/50 hover:scale-105
        transition-all duration-300 ease-out
        border-b-4 border-pink-700 active:border-b-0 active:translate-y-1
        ${fullWidth ? 'w-full' : 'w-auto'}
        ${className}
      `} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} data-id="element-13">
      <ShoppingBag className="w-6 h-6" data-id="element-14" />
      {children}
      <ArrowRight className="w-6 h-6" data-id="element-15" />
    </motion.a>;
}